import { useDispatch } from "react-redux";
import { useEffect, useState } from "react";
import { addAlert } from "src/modules/notification/redux";
import { unwrapResult } from "@reduxjs/toolkit";
import adminRolesApi from "src/configs/apis/admin-roles";
import { useAdminRoleContext } from "../../../contexts/adminRole.context";
import AccessRightDialogComponent from "./admin-access-right-dialog.component";

export default function AdminAccessRightDialogContainer({ handleSubmitted }) {
  const {
    accessRights,
    accessRightOpen,
    setAccessRightOpen,
    isError,
    isLoading,
    isUpdating,
    selectedAdminRole,
  } = useAdminRoleContext();

  const dispatch = useDispatch();
  const [selectedUuids, setSelectedUuids] = useState([]);
  const onCompanyAccessRightDialogCloseClick = () => {
    setAccessRightOpen(false);
  };

  const handleSubmit = async (values) => {
    adminRolesApi.updateRole({
      uuid: selectedAdminRole.uuid,
      name: values.name,
      accessRights: values.selectedUuids,
    }).then(unwrapResult)
    .then(() => {
      dispatch(
        addAlert({
          severity: "success",
          message: "Access rights updated successfully",
        })
      );
      handleSubmitted();
    })
    .catch((error) => {
      dispatch(
        addAlert({
          severity: "error",
          message: error.message,
        })
      );
      handleSubmitted();
    });
  };

  useEffect(() => {
    if (accessRights) {
      const uuids = [];
      accessRights.forEach((group) => {
        group.subgroup.forEach((s) => {
          s.details.forEach((d) => {
            if (d.is_enabled) {
              uuids.push(d.uuid);
            }
          });
        });
      });
      setSelectedUuids(uuids);
    }
  }, [accessRights]);
  return (
    <AccessRightDialogComponent
      open={accessRightOpen}
      accessRights={accessRights}
      isError={isError}
      selectedCompany={selectedAdminRole}
      selectedUuids={selectedUuids}
      handleSubmit={handleSubmit}
      onCompanyAccessRightDialogCloseClick={
        onCompanyAccessRightDialogCloseClick
      }
      isLoading={isLoading}
      isUpdating={isUpdating}
    />
  );
}
